import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FleetTrackerIconService } from './fleet-tracker-icon.service';
import { FleetTrackerUtilityService } from './fleet-tracker-utility.service';
import { FleetTrackerConfig } from './fleet-tracker.config';
import { FleetTrackerService } from './fleet-tracker.service';
import { MapScriptLoaderService } from './map-script-loader.service';

@NgModule({
  imports: [CommonModule],
  declarations: [  ],
  exports: [ ]
})
export class FleetTrackerModule {
    static forRoot(config: FleetTrackerConfig): ModuleWithProviders<FleetTrackerModule> {
        return {
            ngModule: FleetTrackerModule,
            providers: [
                FleetTrackerService,
                MapScriptLoaderService,
                FleetTrackerIconService,
                FleetTrackerUtilityService,
                { provide: FleetTrackerConfig, useValue: config},
                { provide: 'Fleet_Tracker_Service_Token', useValue: FleetTrackerService }
            ]
        };
    }
}
